export const LINK_CODES = {
    SCHEDULE_DEMO_WITH_LIVE_DATA: 'schedule_a_demo_with_live_data',
    ACV_ARTICLE: 'acv_article',
} as const;

export const PAGE_CODES = {
    FREE_HOME: 'free_homepage',
    DOD_FACTS_STEP: 'dod_facts_step',
} as const;
